// extracted by mini-css-extract-plugin
module.exports = {"categoryTitle":"style_categoryTitle__1XekT","categoryText":"style_categoryText__iW5kE"};